import pageStyles from '@/styles/pages/index.module.css';
import type { UserPublic } from '@/types';
import { Breadcrumbs } from '@nautilusbio/nb-design-system/Breadcrumbs';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Link } from '@tanstack/react-router';
import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

type UserActionRowProps = {
  user: UserPublic;
};

export const UserActionRow: FC<UserActionRowProps> = ({ user }) => {
  const { t: tUsers } = useTranslation('users');

  return (
    <Stack alignItems="center" className={pageStyles.titleRow} orientation="horizontal">
      <Breadcrumbs
        links={[
          { id: 'users', children: tUsers('title'), to: '/users' },
          { id: 'user', children: user.full_name },
        ]}
        renderLink={(link, _index, defaultLinkProps) => {
          if (!link?.to) return link?.children;
          return (
            <Link className={defaultLinkProps.className} to={link.to as '/users'}>
              {link.children}
            </Link>
          );
        }}
        separator="arrow"
        size="md"
      />
    </Stack>
  );
};
